import { render, staticRenderFns } from "./MainNavButton.vue?vue&type=template&id=1f49f6fa&scoped=true&"
import script from "./MainNavButton.vue?vue&type=script&lang=ts&"
export * from "./MainNavButton.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavButton.vue?vue&type=style&index=0&id=1f49f6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f49f6fa",
  null
  
)

export default component.exports